import { h } from "preact";
import { useState, useEffect, useContext } from "preact/hooks";

import { makeStyles } from "@mui/styles";
import Carousel from "react-material-ui-carousel";
import BackButton from "../Common/BackButton";

import {
	Box,
	Button,
	Card,
	CardMedia,
	CardActionArea,
	Grid,
	IconButton,
	Paper,
	Stack,
	Tooltip,
	Typography,
} from "@mui/material";

import { AppContext } from "../../AppContext";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import DateRangeIcon from "@mui/icons-material/DateRange";
import ShareIcon from '@mui/icons-material/Share';
import CenterFocusStrongIcon from '@mui/icons-material/CenterFocusStrong';

import FavoriteIcon from '@mui/icons-material/Favorite';

import { SessionContext } from "../../SessionContext";

import Ges from "../GES/";
import Dpe from "../DPE/";

import { ValidateEmail } from "../Common/helpers";
const useStyles = makeStyles((theme) => ({
	button: {
		margin: theme.spacing(1),
	},
	root: {
		maxWidth: 645,
	},
	media: {
		height: 300,
	},
	media2: {
		height: 200,
	},
	ribbon: {
		boxShadow: "0 0 0 2px rgba(63,63,68,0.05), 0 1px 3px 0 rgba(63,63,68,0.15)",
		margin: 0,
		padding: 0,
		background: "#FF3426",
		color: "white",
		padding: "7px 0",
		//padding: "1em 0",
		position: "absolute",
		top: 0,
		left: 0,
		transform: "translateX(-30%) translateY(0%) rotate(-45deg)",
		transformOrigin: "top right",
		"&:before": {
			content: '""',
			position: "absolute",
			top: 0,
			margin: "0 -1px",
			width: "100%",
			height: "100%",
			background: "#FF3426",
			left: "100%",
		},
		"&:after": {
			content: '""',
			position: "absolute",
			top: 0,
			margin: "0 -1px",
			width: "100%",
			height: "100%",
			background: "#FF3426",
			right: "100%",
		},
	},
}));

function Item2(props) {
	const classes = useStyles();
	return (
		<Card className={classes.root}>
			<CardActionArea>
				<CardMedia className={classes.media2} image={props.item.img} title="**" />
			</CardActionArea>
		</Card>
	);
}

export default function PublicPage({ id }) {
	const classes = useStyles();
	const app = useContext(AppContext);
	//const [state, setState] = useState();
	const handleChange = (event) => {
		//console.log(event);
		setState({ ...state, [event.target.name]: event.target.value });
	};
	const [gstate, setGstate] = useContext(SessionContext);
	const [state, setState] = useState(
		{

			open: false,
			id: id,
			handleChange: handleChange,
			conn: gstate.uid && gstate.uid._bkuser !== undefined,
		}

		// window.location.href.startsWith("http://localhost")
		// 	? {
		// 		email: "guillaume.besse+bk@telemetis.com",
		// 		password: "******",
		// 		email2: "guillaume.besse+bk-pr-" + Math.floor(Math.random() * 1000000) + "@telemetis.com",
		// 		fname: "Gui " + Math.floor(Math.random() * 10000),
		// 		lname: "BB" + Math.floor(Math.random() * 1000),
		// 		open: false,
		// 		id: id,
		// 		handleChange: handleChange,
		// 		conn: gstate.uid && gstate.uid._bkuser !== undefined,
		// 	}
		// 	: {
		// 		email: "simon_jammet@hotmail.com",
		// 		email2: "simon_jammet@hotmail.com",
		// 		password: "******",
		// 		fname: "Simon",
		// 		lname: "Jammet" + Math.floor(Math.random() * 1000000),
		// 		open: false,
		// 		id: id,
		// 		handleChange: handleChange,
		// 		conn: gstate.uid && gstate.uid._bkuser !== undefined,
		// 	}
	);

	function Item(props) {
		const classes = useStyles();
		return (
			<Card className={classes.root}>
				<CardActionArea>
					<CardMedia
						className={classes.media}
						image={`${THUMBS_URL}/${id}/${props.item.img}-main.jpg`}
						title="**"
					/>
				</CardActionArea>
			</Card>
		);
	}

	useEffect(() => {
		const requestOptions = {
			method: "GET",
			headers: { "Content-Type": "application/json" },
		};
		fetch("/anon/d4893abcf0b34b6f9a70e537fb3f1507/" + id, requestOptions)
			//fetch("/api/dl/" + id, requestOptions)
			.then((response) => {
				return response.json();
			})
			.then((res) => {
				switch (res.res) {
					case "ok":
						setState((state) => ({
							...state,
							actualDeal: res.pld,
						}));

						break;
					case "err":
						break;
					default:
						break;
				}
			});
	}, []);
	const bookmarkIt = () => {
		const requestOptions = {
			method: "GET",
			headers: { "Content-Type": "application/json" },
		};

		fetch("/api/bkdl/" + id, requestOptions)
			.then((response) => {
				return response.json();
			})
			.then((res) => {
				switch (res.res) {
					case "ok":
						window.location.replace("/publicpage/" + id);

						break;
					case "err":
						break;
					default:
						break;
				}
			});
	};

	const checkAndBookmark = () => {
		if (state.conn) {
			bookmarkIt();
		} else {
			//	setState({ ...state, open: true, action: "B" });
			app.refPopUp.current.handleChangeState(
				{
					opened: true,
					type: "018",
					params: {
						action: "B",
						id: id,


					}
				})
		}
	};

	const checkAndAppoint = () => {
		console.log("checkAndAppoint", gstate);
		app.refPopUp.current.handleChangeState(
			{
				opened: true,
				type: "018",
				params: {
					action: "A",
					id: id,
					connex: gstate.conn, //gstate.uid && gstate.uid._bkuser !== undefined,
					actualDeal: state.actualDeal

				}
			})
		//setState({ ...state, open: true, action: "A" });
	};

	const checkAndMonitor = () => {
		app.refPopUp.current.handleChangeState(
			{
				opened: true,
				type: "018",
				params: {
					action: "M",
					id: id,
					connex: gstate.uid && gstate.uid._bkuser !== undefined,
					actualDeal: state.actualDeal

				}
			})
		//setState({ ...state, open: true, action: "A" });
	};

	const closeAndBookmark = () => {
		//	setState({ ...state, open: false });
		app.refPopUp.current.handleChangeState(
			{
				opened: false,

			})
		bookmarkIt();
	};

	const url_back = (type) => {
		console.log("url_back", type);
		switch (type) {
			case "VN", "VNP":
				return "/11d1355181ac4376a09980601b420617/" + id;
				break;
			case "AC", "ACP":
				return "/1fdf58e512f54752959b369588380557/" + id;
				break;
			case "PR":
				return "/dashboardp";
				break;
			case "AM":
				return "/7bac6cb9d6ee4d70b1315393725f3a34/" + id;
				break;
			default:
				return "/"
				break;
		}
	};

	if (state.actualDeal === undefined) return;
	console.log("state", state, gstate)
	return (
		<div style="padding: 0px;">
			<section style="padding: 10px;">
				<Grid container spacing={2}>
					{(state.actualDeal.role === "PR" || state.actualDeal.role === "VNP" ||
						state.actualDeal.role === "VN" || state.actualDeal.role === "AC" ||
						state.actualDeal.role === "ACP" || state.actualDeal.role === "AM") && <Grid item xs={12}>
							<Paper style="padding: 10px; ">
								<Box display="flex" justifyContent="flex-start" alignItems="center">
									<Box>
										<BackButton tooltip={"Retourner au dossier de vente"} from={url_back(state.actualDeal.role)} />
									</Box>
									<Box>
										<Button
											onClick={() => {
												window.location.href = url_back(state.actualDeal.role);
											}}
										>
											Retourner au dossier de vente
										</Button>
									</Box>
								</Box>
							</Paper>
						</Grid>}
					<Grid item xs={12} md={6}>
						<Paper style="padding-top: 20px; height: 100%">

							<div style="padding: 0px; margin: 0 auto; max-width: 600px; height: 100%">

								{state.actualDeal.pics.length > 0 && (
									<Carousel
										autoPlay={true}
										cycleNavigation={true}
										navButtonsAlwaysVisible={false}
										indicators={true}
										NextIcon={<NavigateNextIcon />}
										PrevIcon={<NavigateBeforeIcon />}
										navButtonsProps={{
											style: {
												borderRadius: "50%",
											},
										}}
									>
										{state.actualDeal.pics.map((item, i) => (
											<Item key={i} item={item} />
										))}
									</Carousel>
								)}

								{state.actualDeal.pics.length == 0 && <Typography>Pas d'images disponibles</Typography>}

							</div>

						</Paper>
					</Grid>
					<Grid item xs={12} md={6}>
						<Paper style="padding: 5px; height: 100%">
							<Grid container spacing={2} style="height: 100%" alignItems="flex-start">
								<Grid item xs={12} sm={6}>
									<div style={{ padding: "0px", position: "relative", overflow: "hidden" }}>
										<span className={classes.ribbon}>{state.actualDeal.ias ? "Vendu" : (state.actualDeal.oabs ? "Offre acceptée" : "Nouveau")}</span>
										<div style={{ paddingLeft: "30px", paddingTop: "80px" }}>
											<Stack spacing={1}>

												<Typography variant="h5" style="font-size: 25px;">{state.actualDeal.mn}</Typography>
												<Typography variant="h5" style="margin-bottom: 20px; font-size: 18px;">{state.actualDeal.mn2}</Typography>
												<Typography variant="h5" style="margin-bottom: 20px; font-size: 20px;">{state.actualDeal.p}€</Typography>
												<Typography variant="body1">{state.actualDeal.tp}</Typography>
												<Stack flexDirection={"row"} justifyContent="flex-start" alignItems="center">
													{state.actualDeal.nb_r > 0 && <Typography style="margin-right: 10px;" variant="body1">{state.actualDeal.nb_r} pièce{state.actualDeal.nb_r > 1 ? "s" : ""} - </Typography>}
													<Typography variant="body1">{state.actualDeal.surf} m2</Typography>
												</Stack>
												{state.actualDeal.nb_br > 0 && <Typography variant="body1">{state.actualDeal.nb_br} chambre{state.actualDeal.nb_br > 1 ? "s" : ""}</Typography>}

											</Stack>
										</div>
									</div>
								</Grid>
								<Grid item xs={12} sm={6}>
									<Box display="flex" flexDirection="row" alignItems="center" justifyContent="center" p={1} m={1}>
										<Box p={1}>
											<img
												alt={`Lieu du ${state.actualDeal.mn}`}
												src={`https://api.mapbox.com/styles/v1/mapbox/streets-v11/static/pin-s+ea5140(${state.actualDeal.ln},${state.actualDeal.lt})/${state.actualDeal.ln},${state.actualDeal.lt},15,0/250x250?access_token=pk.eyJ1IjoidGVsZW1ldGlzIiwiYSI6ImNrcWZvd2c0MzByM2wybnNjOGR2c2JtNGEifQ.npIdy2KCcctfSjvVWcSDXw`}
											/>
										</Box>
									</Box>
								</Grid>
								<Grid item xs={6}>
									<Box display="flex" flexDirection="row" alignItems="center" justifyContent="flex-start" p={1} m={1}>
										{!state.bk && !state.actualDeal.bk && (
											<Box p={1}>
												<Tooltip title="Mettre ce bien dans mes favoris">
													<IconButton color="primary" onClick={checkAndBookmark}>
														<FavoriteIcon />
													</IconButton>
												</Tooltip>
											</Box>
										)}
										{state.bk && state.actualDeal &&
											state.actualDeal.bk && (
												<Box p={1}>
													<Typography variant="body1">Ce bien est dans vos favoris 😻</Typography>
												</Box>
											)}
										<Box p={1}>
											<Tooltip title="Partager ce bien">
												<IconButton color="primary" onClick={() => {
													app.refPopUp.current.handleChangeState(
														{
															opened: true,
															type: "019",
															params: {
																uid: id

															}
														})
												}}>
													<ShareIcon />
												</IconButton>
											</Tooltip>
										</Box>
										<Box p={1}>
											<Tooltip title="Nous avons des biens similaires">
												<IconButton color="primary" onClick={() => { }}>
													<CenterFocusStrongIcon />
												</IconButton>
											</Tooltip>
										</Box>
									</Box>
								</Grid>
								<Grid item xs={6}>
									{state.actualDeal.pub && <Box display="flex" flexDirection="row" alignItems="center" justifyContent="center" p={1} m={1}>

										{!state.actualDeal.oabs && (
											<Box p={1}>
												<Button variant="contained" onClick={checkAndAppoint} endIcon={<DateRangeIcon />}>
													Prendre rendez-vous
												</Button>
											</Box>
										)}
										{state.actualDeal.oabs && (
											<Box p={1}>
												<IconButton color="primary">
													<Button variant="contained" onClick={checkAndMonitor}>Surveiller</Button>
												</IconButton>
											</Box>
										)}
									</Box>}
								</Grid>
							</Grid>
						</Paper>
					</Grid>
				</Grid>
			</section>
			<section style="padding: 10px;">
				<Grid container spacing={2}>
					<Grid item xs={12} md={6}>
						<Paper style="padding-top: 30px; padding-bottom: 20px; padding-left: 40px; padding-right: 40px; height: 100%">
							<Stack spacing={3} >
								<Typography variant="h4" style="white-space: pre-wrap;line-height: normal;">
									{state.actualDeal.d}
									{/* {state.actualDeal.d.replace(/(\r\n|\r|\n)/g, '<br />')} */}
								</Typography>
								<Grid container>
									{state.actualDeal.traits && state.actualDeal.traits.map((i) => {
										return (<Grid xs={6}>
											<Box display={"flex"} alignItems="center">
												<Box  > <Typography variant="h5">{i.lbl}</Typography></Box>
												<Box p={1}><Typography>{i.cnt}</Typography></Box>
											</Box>
										</Grid>)
									})}
								</Grid>
								{/* <Box display={"flex"} alignItems="flex-end" justifyContent={"space-between"}>
									{state.actualDeal.traits && state.actualDeal.traits.map((i) => {
										return (<Box display={"flex"} alignItems="center">
											<Box  > <Typography variant="h5">{i.lbl}</Typography>  </Box>
											<Box p={1}><Typography>{i.cnt}</Typography></Box>
										</Box>)
									})}
								</Box> */}
							</Stack>
						</Paper>
					</Grid>
					<Grid item xs={12} md={6}>
						<Paper style="padding-top: 30px; padding-bottom: 20px; padding-left: 40px; padding-right: 40px; height: 100%">
							<Grid container spacing={1}>
								<Grid item xs={12} sm={6}>

									{state.actualDeal.dpe && <Dpe dpe={state.actualDeal.dpe} ges={state.actualDeal.ges} />}
									{!state.actualDeal.dpe && <Paper>
										<Box display={"flex"} alignItems="center"><Box p={1}><Typography>Données de DPE indisponibles</Typography></Box></Box>
									</Paper>}
								</Grid>
								<Grid item xs={12} sm={6}>
									{state.actualDeal.ges && <Ges dpe={state.actualDeal.dpe} ges={state.actualDeal.ges} />}
									{!state.actualDeal.ges && <Paper>
										<Box display={"flex"} alignItems="center"><Box p={1}><Typography>Données de GES indisponibles</Typography></Box></Box>
									</Paper>}
								</Grid>
							</Grid>


							{/* <Box display="flex" alignItems="center" justifyContent="space-evenly" p={1} m={1} style="height: 100%">
								<Box p={1}>
									{state.actualDeal.dpe && <Dpe dpe={state.actualDeal.dpe} ges={state.actualDeal.ges} />}
									{!state.actualDeal.dpe && <Paper>
										<Box display={"flex"} alignItems="center"><Box p={1}><Typography>Données de DPE indisponibles</Typography></Box></Box>
									</Paper>}
								</Box>
								<Box p={1}>
									{state.actualDeal.ges && <Ges dpe={state.actualDeal.dpe} ges={state.actualDeal.ges} />}
									{!state.actualDeal.ges && <Paper>
										<Box display={"flex"} alignItems="center"><Box p={1}><Typography>Données de GES indisponibles</Typography></Box></Box>
									</Paper>}
								</Box>

							</Box> */}
						</Paper>
					</Grid>
				</Grid>
			</section>
			{
				false && <section style="padding: 10px; ">
					<Paper style="padding: 10px;">
						<Typography variant="h6" style="margin-bottom: 10px;">
							Vous pourriez aimer aussi...
						</Typography>
						<Grid container spacing={1}>
							<Grid item xs={3}>
								<Item2 item={{ img: "/images/img5.jpg" }} />
							</Grid>

							<Grid item xs={3}>
								<Item2 item={{ img: "/images/img6.jpg" }} />
							</Grid>

							<Grid item xs={3}>
								<Item2 item={{ img: "/images/img7.jpg" }} />
							</Grid>
							<Grid item xs={3}>
								<Item2 item={{ img: "/images/img4.jpg" }} />
							</Grid>
						</Grid>
					</Paper>
				</section>
			}
		</div >
	);
}

